// export { default as Create } from './create'
// export { default as Edit } from './edit'

import Create from './create'
import Edit from './edit'

export { Create, Edit }



// WEBPACK FOOTER //
// ./src/pages/widgets/competition/index.js